/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Suspense } from "react";
import { ResetPasswordForm } from "./ResetPasswordForm";
const LoginPage = (param)=>{
    let { params: { lng } } = param;
    return /*#__PURE__*/ _jsx(Suspense, {
        children: /*#__PURE__*/ _jsx(ResetPasswordForm, {
            lng: lng
        })
    });
};
export default LoginPage;
